import React, { useState } from "react";
import axios from "axios";

const Delete = ({ itemId, apiEndpoint, onDelete }) => {
  const [loading, setLoading] = useState(false);

  const handleDelete = async () => {
    setLoading(true);
    try {
      const response = await axios.delete(`${apiEndpoint}/${itemId}`);
      if (response.status === 200) {
        onDelete(itemId); // Notify parent
      } else {
        alert("Failed to delete the item. Please try again.");
      }
    } catch (error) {
      alert("An error occurred while deleting the item.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      onClick={handleDelete}
      className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600 disabled:bg-gray-400"
      disabled={loading}
    >
      {loading ? "Deleting..." : "Yes, Delete"}
    </button>
  );
};

export default Delete;
